export { default as HomePage } from './HomePage';

export { default as Complete } from './Complete';

export { default as Activity } from './Activity';
export { default as IAS } from './IAS';
export { default as IOBSP } from './IOBSP';
export { default as Declarations } from './Declarations';
export { default as Informations } from './Informations';
export { default as Validation } from './Validation';
export { default as Payment } from './Payment';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/index.ts